import { useInstance } from "@meraki-internal/react-dependency-injection";
import { APIClient } from "../support/api/APIClient";
import { useState } from "react";
import ReactImageUploading, { ImageListType } from "react-images-uploading";
import { Image } from "./Image";

interface EditableImageProps {
    src?: string;
    onChange: (src: string) => void;
    size?: number;
    onIsUploading: (isUploading: boolean) => void;
}

export const EditableImage: React.FC<EditableImageProps> = ({ size = 240, src, onChange, onIsUploading }) => {
    const apiClient = useInstance(APIClient);

    const [image, setImage] = useState<{ dataUri?: string }>({ });

    const onFileAdded = async (
        imageList: ImageListType,
    ) => {
        const { file, dataURL } = imageList[0];

        if (file){
            setImage({
                dataUri: dataURL
            });
            onIsUploading(true);
            const { cdnUrl, headers, uploadUrl  } = await apiClient.post(`/foundations/blackhills-robotics/clubs/spartan-robotics/images`, {
                fileName: file?.name
            });

            const res = await window.fetch(uploadUrl, {
                method: 'PUT',
                body: file,
                headers,
            });
            if (res.status !== 200){
                throw new Error(`Upload failed with status ${res.status}`);
            }
            setImage({
                dataUri: undefined,
            });

            onChange(cdnUrl);

            // TODO: better UX on upload fail (currently gets stuck)
            onIsUploading(false);
        }
    };

    return (
        <div className="App">
            <ReactImageUploading
                value={[]}
                onChange={onFileAdded}
                maxNumber={1}
            >
                {({
                    onImageUpload,
                    isDragging,
                    dragProps
                }) => (
                    // TODO: is dragging seems to be false when I wouldn't expect it
                    <div
                        className="upload__image-wrapper"
                        {...dragProps}
                        onClick={onImageUpload}
                        style={isDragging ? { border: 'solid 2px var(--ion-color-primary)'} : { border: 'solid 2px white'} }
                    >
                        <Image src={image.dataUri || src} size={size}/>
                    </div>
                )}
            </ReactImageUploading>
        </div>
    );
}
